const STYLE_ID = 'branch-theme'

const buildCss = colours => {
  const { primary, primaryForeground, chrome, chromeForeground } = colours

  return `
    .navbar {
      background-color: ${chrome} !important;
    }
    .navbar-item,
    .navbar .menu-item,
    .navbar .nav-menu-item,
    .navbar .nav-menu-item:hover,
    .navbar .caret-down-color {
      color: ${chromeForeground} !important;
    }
    .button.is-info {
      background-color: ${primary} !important;
      color: ${primaryForeground} !important;
    }
    .button.is-image-tick {
      background-color: ${primary} !important;
    }
  `
}

export const applyTheme = colours => {
  if (!colours) return clearTheme()

  let style = document.getElementById(STYLE_ID)
  if (!style) {
    style = document.createElement('style')
    style.id = STYLE_ID
    document.head.appendChild(style)
  }
  style.textContent = buildCss(colours)
}

export const clearTheme = () => {
  const style = document.getElementById(STYLE_ID)
  if (style) style.remove()
}
